export default {
  base: {
    back: 'retour',
    add: 'ajouter',
    delete: 'supprimer'
  },
  title: {
    app: 'Vaquant',
    about: 'À propos',
    pricing: 'Offres'
  },
  account: {
    open: 'Ouvrir à nouveau',
    close: 'Cloturer',
    closed: 'Compte cloturé',
    create: 'Créer un compte',
    new: 'Nouveau compte',
    setting: 'Paramètre : {name}',
    users: 'Utilisateurs',
    danger_zone: 'Zone de danger',
    delete: 'Supprimer le compte',
    main_currency: 'Devise principale',
    use_currency: `Utiliser d'autre devises`,
    used_currencies: 'Devise utilisée | {count} devises utilisées',
    friends: `Seul | Avec un ami | Avec {count} amis`,
    amount_name: 'Dépense',
    payed_by: 'Payée par',
    none: 'Pas de compte actuellement',
    total: `Il n'y a actuellement aucune dépense. | Il y a une dépense. | Il y a {count} dépenses.`,
    publicInformation: `Toutes les personnes accédant à ce compte
    pourront ajouter, modifier et supprimer des dépenses.`,
    privateInformation:
      'Seul les amis inscrits à ce compte pourront ajouter, modifier et supprimer des dépenses.',
    newUserAdded: `L'ami a été ajouté | Les amis ont été ajoutés`
  },
  about: {
    description: `
      Vaquant est une application qui réalise
      des balances équitables de vos budgets entre
      amis lors de vos colocations, vacances, séjours,
      voyages, etc.`
  },
  transaction: {
    weight: 'part | part | parts',
    money: 'Aucune monnaie | Autre monnaie | Autres monnaies',
    split: 'Aucune part | 1 part | {count} parts'
  },
  user: {
    account: 'Compte',
    loginsignup: `Se connecter / S'inscrire`,
    login: 'se connecter',
    signup: `s'inscrire`,
    password: 'mot de passe',
    confirm_password: 'confirmer le mot de passe',
    alias: 'alias',
    email: 'email',
    firstname: 'prénom',
    lastname: 'nom',
    connectedwith: `Vous êtes connecté avec l'identifiant`,
    logout: 'se déconnecter',
    delete: 'supprimer mon profil',
    purge: 'Réinitialiser les données',
    purgeDone: 'Réinitialisation des données effectuées avec succès.',
    pseudo: 'identifiant'
  },
  validation: {
    max_char: 'limite atteinte | 1 caractère maximum | {max} caractères maximum'
  }
}
